export default {
  name: '星形',
  title: 'Polygone/Star Tool',
  buttons: [
    {
      title: '星形工具'
    },
    {
      title: '多边形工具'
    }
  ],
  contextTools: [
    {
      title: '顶点',
      label: '顶点'
    },
    {
      title: '钝度',
      label: '钝度'
    },
    {
      title: '径向',
      label: '径向'
    },
    {
      title: '边数',
      label: '边数'
    }
  ]
};
